module.exports = __webpack_public_path__ + "img/various-rocket.b45b3fe5.svg";